import { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Copies `text` to the clipboard and confirms for two seconds. Scoped to the
 * bank details a payer retypes by hand (account number, transfer memo) —
 * mirrors `apps/web/app/components/invoice/CopyButton.tsx`'s treatment for
 * the public invoice, but lives in the dashboard since the two apps don't
 * share components across the app boundary.
 */
export function CopyButton({ text }: { text: string }) {
  const { t } = useTranslation('billing');
  const [copied, setCopied] = useState(false);

  return (
    <button
      type="button"
      onClick={() => {
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }}
      className="inline-flex items-center gap-1 text-xs text-brand-600 transition-colors hover:text-brand-700"
    >
      {copied ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}
      {copied ? t('invoice.copied') : t('invoice.copy')}
    </button>
  );
}
